import React from "react";
import { useSelector } from "types/store";
import Select from "react-select";
import * as homeReducer from "containers/Home/reducer";
import { selectOnChangeWrapper, selectOnChangeWrapperMulti } from "utils/select";
const DatasetColumnSelection = ({ datasetId, value, onChange, optionsFilter, placeholder, type, isMulti, isClearable, disabled }) => {
    const fields = useSelector((state) => homeReducer.getFieldsArr(state, datasetId)) ?? [];
    const columnOptions = fields
        .filter((field) => {
        if (optionsFilter && !optionsFilter(field)) {
            return false;
        }
        if (type !== undefined) {
            if (typeof type === "string") {
                return field.type === type;
            }
            if (Array.isArray(type) && type.length) {
                if (field.isNumeric && type.includes("number")) {
                    return true;
                }
                return type.includes(field.type);
            }
        }
        return true;
    })
        .map((field) => ({ value: field.label, label: field.label }));
    let selectedValue = undefined;
    if (value !== undefined) {
        if (isMulti && Array.isArray(value)) {
            selectedValue = value?.map((v) => {
                return columnOptions.find((o) => o.value === v) ?? { label: v, value: v };
            });
        }
        else {
            selectedValue =
                columnOptions.find((o) => o.value === value) ?? { label: value, value: value };
        }
    }
    const retOnChange = isMulti ? selectOnChangeWrapperMulti(onChange) : selectOnChangeWrapper(onChange);
    // Unique use case when React Reconciliation fails to update the value of the select component. To prevent this, added a wrapper to the select component and force a re-render.
    if (!selectedValue) {
        return (React.createElement("div", null,
            React.createElement(Select, { className: "dirty-hack", value: undefined, options: columnOptions, onChange: retOnChange, isSearchable: true, placeholder: placeholder, isMulti: isMulti, isClearable: isClearable, maxMenuHeight: 200, menuPlacement: "top", isDisabled: disabled })));
    }
    return (React.createElement(Select, { value: selectedValue, options: columnOptions, onChange: retOnChange, isSearchable: true, placeholder: placeholder, isMulti: isMulti, isClearable: isClearable, maxMenuHeight: 200, menuPlacement: "top", isDisabled: disabled }));
};
export default DatasetColumnSelection;
